module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921002649_T.c11a9d51.jpg";